module.exports = __webpack_public_path__ + "media/LandingPageAssets/GooglePlayIcon-12df2796.png";